/**
 * Part 18, G7, G8: an imported chapter's pictures settled once the page has added them to the book. Each placeholder
 * destination the converter wrote (a random ID and a zero hash, part 16a's shape) is replaced by the stored image's
 * reference: the same length and the same characters' kinds, so a canonical text stays canonical. A picture that
 * couldn't be added keeps its placeholder, which names no image, so the preview shows its placeholder box and the
 * alt text stays the writer's to see. Pure.
 */

/** `text` with each placeholder of `added` replaced by the destination it maps to. */
export function settleImages(text: string, added: ReadonlyMap<string, string>): string {
  let out = text;
  for (const [placeholder, destination] of added) out = out.replaceAll(placeholder, destination);
  return out;
}
